module.exports = __webpack_public_path__ + "static/media/Heart-1s-33px.344eec02.svg";